import { render, staticRenderFns } from "./RankingList.vue?vue&type=template&id=737aaf22&scoped=true&"
import script from "./RankingList.vue?vue&type=script&lang=js&"
export * from "./RankingList.vue?vue&type=script&lang=js&"
import style0 from "./RankingList.vue?vue&type=style&index=0&id=737aaf22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737aaf22",
  null
  
)

export default component.exports